import { isDesk, type Viewer } from '@alphadesk/web/contract.ts';
import type { RoutePath } from '@alphadesk/web/links.ts';
import { lazy } from 'react';
import { files } from '../lib/nav.ts';
import { lazyPage, type RouteComponent } from './route.tsx';

interface Route {
  path: RoutePath;
  /** Unmet, the page is "no such page", not a refusal: the table ships in the bundle anyway. */
  guard: (viewer: Viewer) => boolean;
  component: RouteComponent;
  /** Drawn where the inbox's rail would be. */
  rail?: RouteComponent;
}

const anyone = (): boolean => true;
const member = (viewer: Viewer): boolean => viewer.memberId !== null;

/** Every page of the console, each in its own chunk. Matched by `routeOf`, shared with the server. */
export const ROUTE_TABLE: readonly Route[] = [
  {
    path: '/',
    guard: anyone,
    component: lazyPage(() => import('../components/pages/Home.tsx').then((m) => m.HomePage)),
    rail: lazyPage(() => import('../components/home/TodayRail.tsx').then((m) => m.TodayRail)),
  },
  {
    path: '/trades',
    guard: anyone,
    component: lazyPage(() => import('../components/pages/Trades.tsx').then((m) => m.TradesPage)),
    rail: lazyPage(() => import('../components/NewsRail.tsx').then((m) => m.NewsRail)),
  },
  { path: '/r/:id', guard: anyone, component: lazy(() => import('./Recommendation.tsx')) },
  {
    path: '/analysts',
    guard: anyone,
    component: lazyPage(() =>
      import('../components/pages/Analysts.tsx').then((m) => m.AnalystsPage),
    ),
  },
  { path: '/analysts/:id', guard: anyone, component: lazy(() => import('./Analyst.tsx')) },
  {
    path: '/pnl',
    guard: member,
    component: lazyPage(() => import('../components/pages/Pnl.tsx').then((m) => m.PnlPage)),
  },
  { path: '/investments', guard: member, component: lazy(() => import('./Investments.tsx')) },
  { path: '/markets', guard: anyone, component: lazy(() => import('./Markets.tsx')) },
  { path: '/inbox', guard: anyone, component: lazy(() => import('./Inbox.tsx')) },
  { path: '/add', guard: files, component: lazy(() => import('./Add.tsx')) },
  { path: '/account', guard: anyone, component: lazy(() => import('./Account.tsx')) },
  { path: '/desk', guard: isDesk, component: lazy(() => import('./Desk.tsx')) },
  {
    path: '/help',
    guard: anyone,
    component: lazyPage(() => import('../components/pages/Help.tsx').then((m) => m.HelpPage)),
    rail: lazyPage(() => import('../components/pages/Help.tsx').then((m) => m.ManualRail)),
  },
];
